import pickLocationMap from "./pickLocationMap.component";

const pickLocationMapModule = angular
  .module("app.components.pickLocationMap", [])
  .component("pickLocationMap", pickLocationMap);

export default pickLocationMapModule;



// WEBPACK FOOTER //
// ./src/components/pickLocationMap/pickLocationMap.module.js